import React from 'react';
import { AUTOMATION_TYPES } from '@/utils/constants/automations';

import WarningModal from '@/components/common-components/ModalComponent/WarningModal';

interface PauseAutomationModalInterface {
  show: boolean;
  onClose: () => void;
  setStatus: React.Dispatch<React.SetStateAction<string>>;
  handlePause: (status: string) => void;
  loading: boolean;
  type: string;
}

const PauseAutomationModal: React.FC<PauseAutomationModalInterface> = ({
  show,
  onClose,
  handlePause,
  loading,
  type,
}) => {
  const handlePauseAutomation = () => {
    handlePause('paused');
  };

  return (
    <WarningModal
      show={show}
      onClose={onClose}
      icon="⚠️"
      iconBgColor="var(--yellow-y-50)"
      title="Pause Automation?"
      description={
        <>
          <p className="text-center">
            Pausing this automation will stop all <br /> upcoming{' '}
            {type === AUTOMATION_TYPES.SHIPMENT ? 'shipments' : 'payments'}.
          </p>
          <p className="mt-6 text-center">
            You can resume it anytime using the edit icon under &quot;
            {type === AUTOMATION_TYPES.SHIPMENT ? 'Ship Free Product' : 'Payments'}&quot;
          </p>
        </>
      }
      actionButtonText="Okay, Pause"
      actionButtonType="primary"
      actionFunction={handlePauseAutomation}
      cancelButtonText="Cancel"
      width={420}
      outsideClickClose={false}
      showLoading={loading}
    />
  );
};

export default PauseAutomationModal;
